import qs from "qs";

export class ProjectClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/projects`;
  }

  async list() {
    const url = `${this.baseURL}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async search(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/search${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getPhoneDirectory(id) {
    const url = `${this.baseURL}/${id}/phone_directory`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getInstructionProgress(id) {
    const url = `${this.baseURL}/${id}/instruction_progresses`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async postInstructionProgress(id, data) {
    const url = `${this.baseURL}/${id}/instruction_progresses`;

    const response = await this.httpClient.request("post", url, { data });

    return response;
  }

  async putInstructionProgress(id, data) {
    const url = `${this.baseURL}/${id}/instruction_progresses`;

    const response = await this.httpClient.request("put", url, { data });

    return response;
  }

  async postPhoneDirectory(id, data) {
    const url = `${this.baseURL}/${id}/phone_directory`;

    const response = await this.httpClient.request("post", url, { data });

    return response;
  }

  async getAllProjectGroup() {
    const url = `${this.baseURL}/AllProjectGroup`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getSegmentHome(segmentIds) {
    const queryString = qs.stringify(segmentIds, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/segmentHome${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/projects.js